import {
  Box, Grid, List, ListItemButton,
  Stack,
  Typography,
} from '@mui/material';
import { MutedText } from '../../../../components/CustomTypography';

function CustomFilterContent({ data }) {
  return (
    <Grid container direction="column">
      {data?.length ? (
        <Grid item>
          <List>
            <MutedText text="WatchList" sxProps={{ mx: 2 }} />
            {data.map((item, i) => (
              <Box key={item.id}>
                <ListItemButton
                  onClick={item.onClick}
                  sx={(theme) => ({
                    background: i % 2 !== 0 && theme.palette.grey[100],
                  })}
                >
                  <Stack justifyContent="space-between" gap={2} direction="row" width="100%" alignItems="center">
                    <Typography>{item.text}</Typography>
                    <MutedText
                      text={item.count}
                      sxProps={{
                        color: 'primary.text',
                        backgroundColor: 'primary.lighter',
                        borderRadius: '25px',
                        padding: '2px 8px',
                      }}
                    />
                  </Stack>
                </ListItemButton>
              </Box>
            ))}
          </List>
        </Grid>
      ) : null}
    </Grid>
  );
}

export default CustomFilterContent;
